import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
  memo,
  useCallback,
  useMemo,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Menu, Dropdown, Button, Select, Input } from "antd";
import { Div } from "../billing/CardTransactions/styles";
import { Modal } from "react-bootstrap";
import Signature from "../../assets/images/Signature.png";
import { DownOutlined } from "@ant-design/icons";
import template1 from "../../assets/images/template1.png";
import template2 from "../../assets/images/template2.png";
import template3 from "../../assets/images/template3.png";
import template4 from "../../assets/images/template4.png";
import template5 from "../../assets/images/template5.png";
import template6 from "../../assets/images/template6.png";
import template7 from "../../assets/images/template7.png";
import template8 from "../../assets/images/template8.png";
import template9 from "../../assets/images/template9.png";
import template10 from "../../assets/images/template10.png";
import template11 from "../../assets/images/template11.png";
import datachip1 from "../../assets/images/datachip1.png";
import datachip2 from "../../assets/images/datachip2.png";
import datachip3 from "../../assets/images/datachip3.png";
import axiosInstance from "../../axios/axios";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "./GetStartedPopup";

function EditDocument(
  {
    ExtraContent,
    data,
    fromWhere,
    Mode,
    setContentToParent,
    clearExtraContent,
    onOpenCodePopup,
    fromTemplate,
    pid,
    encounter,
  },
  ref,
) {
  const [content, setContent] = useState(data || "");
  const inputboxRef = useRef(1);
  const editorRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const step = query.get("step");
  const [DropDownPopup, setDropDownPopup] = useState(false);
  const [Multiple, setMultiple] = useState(false);

  // Premium Options State
  const [options, setOptions] = useState([]);

  const [dropdownPlaceholder, setDropdownPlaceholder] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const { Option } = Select;

  const onOpenCodePopupRef = useRef(onOpenCodePopup);
  useEffect(() => {
    onOpenCodePopupRef.current = onOpenCodePopup;
  }, [onOpenCodePopup]);

  // ─── Core Logic for Data Preservation ───

  // This function is the "Heart" of the fix.
  // It forces the physical DOM attributes to match the user's typed input.
  // Without this, innerHTML and Jodit's serializer don't see the typed text.
  const [macrosList, setMacrosList] = useState([]);

  useEffect(() => {
    let endpoint = "/vozo/patient/getmacrobutton";
    if (pid && encounter) {
      // Encrypt the data to match the backend expectation
      const Encrypt_Value =
        require("../../MiddleWare/EncryptDecrypt").Encrypt_Value;
      let encryptedData = Encrypt_Value({ pid, encounter }, "vozo");
      endpoint += "?data=" + encryptedData;
    }
    axiosInstance
      .get(endpoint)
      .then((response) => {
        let decoded = Decrypt_Value(response.data, "vozo");
        if (Array.isArray(decoded)) {
          setMacrosList(decoded);
        }
      })
      .catch((err) => {
        console.error("Error fetching macros in EditDocument:", err);
      });
  }, [pid, encounter]);

  // Ensure options are initialized whenever the popup is opened for a new field
  useEffect(() => {
    if (DropDownPopup && options.length === 0) {
      setOptions([
        { text: "", checked: false },
        { text: "", checked: false },
      ]);
    }
  }, [DropDownPopup]); // Only trigger on open state change

  const syncAttributes = useCallback((container) => {
    if (!container) return;

    // Process all inputs
    container.querySelectorAll("input").forEach((el) => {
      if (el.type === "radio" || el.type === "checkbox") {
        if (el.checked) el.setAttribute("checked", "checked");
        else el.removeAttribute("checked");
      } else {
        // Essential: Mirror the 'value' property to the 'value' attribute
        el.setAttribute("value", el.value);
      }
    });

    // Process all selects
    container.querySelectorAll("select").forEach((el) => {
      // 1. Multi-select N+1 fix:
      // Strip 'selected' from the placeholder (disabled/hidden, value="") so the browser
      // NEVER counts it in selectedOptions.length. Also patch Jodit's inner HTML model so
      // the fix survives Jodit re-renders (without this, Jodit re-injects the raw HTML
      // with 'selected' still present and the count goes back to N+1).
      if (el.multiple && el.options.length > 0) {
        const firstOpt = el.options[0];
        const isPlaceholder =
          firstOpt.hasAttribute("hidden") ||
          firstOpt.hasAttribute("disabled") ||
          firstOpt.getAttribute("value") === "" ||
          firstOpt.value === "";

        if (isPlaceholder && firstOpt.hasAttribute("selected")) {
          firstOpt.selected = false;
          firstOpt.removeAttribute("selected");
        }
      }

      // 2. Attribute Mirroring for real options
      if (!el.multiple) {
        el.setAttribute("value", el.value);
      }
      Array.from(el.options).forEach((opt, idx) => {
        // Skip the placeholder on multiple selects (already handled above)
        if (el.multiple && idx === 0) {
          const fp = el.options[0];
          if (
            fp.hasAttribute("hidden") ||
            fp.hasAttribute("disabled") ||
            fp.getAttribute("value") === "" ||
            fp.value === ""
          )
            return;
        }
        if (opt.selected) opt.setAttribute("selected", "selected");
        else opt.removeAttribute("selected");
      });
    });
  }, []);

  const insertContent = useCallback(
    (test) => {
      const instance = editorRef.current;
      if (instance && instance.editor) {
        const editorEl = instance.editor;
        const editorDoc = editorEl.ownerDocument;

        // 1. Force commit the active element if it's an input/select
        const activeEl = editorDoc.activeElement;
        if (
          activeEl &&
          (activeEl.tagName === "INPUT" || activeEl.tagName === "SELECT")
        ) {
          activeEl.setAttribute("value", activeEl.value);
          if (activeEl.type === "radio" || activeEl.type === "checkbox") {
            if (activeEl.checked) activeEl.setAttribute("checked", "checked");
            else activeEl.removeAttribute("checked");
          }
        }

        // 2. Full capture of current state into attributes
        syncAttributes(editorEl);

        // 3. Synchronize Jodit's model
        if (instance.synchronize) instance.synchronize();

        // 4. Insert the HTML
        const selection = instance.s || instance.selection;
        selection.insertHTML(test);

        // 5. Final sync after a tiny delay to allow Jodit to process the insertion
        setTimeout(() => {
          syncAttributes(editorEl);
          if (instance.synchronize) instance.synchronize();

          const finalHTML = editorEl.innerHTML;
          instance.value = finalHTML;
          setContent(finalHTML);
          setContentToParent(finalHTML);
        }, 10);
      } else {
        setContent((prevContent) => {
          if (!prevContent) return test;
          if (prevContent.endsWith("</p>")) {
            return prevContent.replace(/<\/p>$/, test + "</p>");
          }
          return prevContent + test;
        });
      }
    },
    [syncAttributes, setContentToParent],
  );

  // ─── Premium Modal Helper Functions ───
  const updateOption = (index, value) => {
    setOptions((prev) =>
      prev.map((opt, i) => (i === index ? { ...opt, text: value } : opt)),
    );
  };

  const deleteOption = (index) => {
    setOptions((prev) => prev.filter((_, i) => i !== index));
  };

  const addBlankOption = () => {
    setOptions((prev) => [...prev, { text: "", checked: false }]);
  };

  const addOtherOption = () => {
    setOptions((prev) => {
      const alreadyHasOther = prev.some(
        (opt) => opt.text.trim().toLowerCase() === "other",
      );
      if (alreadyHasOther) return prev;
      return [...prev, { text: "Other", checked: false }];
    });
  };

  const toggleOption = (index) => {
    // Disable selection in the modal entirely as per request
    return;
  };

  const handleOkDropdown = () => {
    // Validation: Require at least 2 options with text
    const validOptions = options.filter((opt) => opt.text.trim() !== "");
    if (validOptions.length < 2) {
      setErrorMessage("Please fill at least 2 options");
      return;
    }
    setErrorMessage(""); // Clear error on success

    let test;
    // Default placeholders based on type
    const placeholder =
      dropdownPlaceholder ||
      (Multiple ? "Select multiple option" : "Select an option");
    const selectClass = "sizedinputselect"; // Use same class for both to match styling
    const multipleAttr = Multiple ? 'multiple size="1"' : ""; // size="1" helps multibox look like dropdown

    const currentId = inputboxRef.current;
    const selectedOptions = options.filter((opt) => opt.checked);
    const isAnySelected = selectedOptions.length > 0;

    if (Multiple) {
      let selectHTML = `<select class="${selectClass}" ${multipleAttr} name="${currentId}" data-input-id="${currentId}">`;
      // CRITICAL: placeholder must NEVER have 'selected' attribute — not even when nothing
      // is chosen. If 'selected' is baked into the HTML, Jodit stores it in its model and
      // restores it on every re-render, making syncAttributes unable to win the race.
      selectHTML += `<option disabled hidden value="">${placeholder}</option>`;
      options.forEach((option) => {
        // Only include options that have text
        if (option.text.trim()) {
          selectHTML += `<option ${option.checked ? "selected" : ""} value="${option.text}">${option.text}</option>`;
        }
      });
      selectHTML += `</select>`;
      test = selectHTML;
    } else {
      let selectHTML = `<select class="${selectClass}" name="${currentId}" data-input-id="${currentId}">`;
      if (!isAnySelected) {
        selectHTML += `<option disabled hidden selected value="">${placeholder}</option>`;
      }
      options.forEach((option) => {
        // Only include options that have text
        if (option.text.trim()) {
          selectHTML += `<option ${option.checked ? "selected" : ""} value="${option.text}">${option.text}</option>`;
        }
      });
      selectHTML += `</select>`;
      test = selectHTML;
    }

    inputboxRef.current += 1;
    insertContent(test);
    setDropDownPopup(false);
    setOptions([]);
    setDropdownPlaceholder("");
  };

  const setEditorData = (e) => {
    let test = "";
    const currentId = inputboxRef.current;
    if (e === "TextInput") {
      test = `<input type="text" class="inputbox" data-input-id="${currentId}" value />`;
    } else if (e === "smTextInput") {
      test = `<input type="text" class="sminput" data-input-id="${currentId}" value />`;
    } else if (e === "sizedTextInput:120px") {
      test = `<input type="text" class="sizedinput" data-input-id="${currentId}" value/>`;
    } else if (e === "DatePicker") {
      test = `<input type="date" data-input-id="${currentId}" class="datepicker" value/>`;
    } else if (e === "Radio button") {
      test = `<input type="radio" class="radioboxGroup" data-input-id="${currentId}" name="group${currentId}" value/>`;
    } else if (e === "ynRadioGroup") {
      // FIXED: Added container and &nbsp; to place cursor after the radio group
      test = `<span class="yn-radio-wrapper" style="display: inline-flex; align-items: center; gap: 16px;"><label style="display: inline-flex; align-items: center; gap: 4px; cursor: pointer;"><input type="radio" class="radiobox" data-input-id="${currentId}" name="${currentId}ynRadioGroup" value="Yes"/></label><label style="display: inline-flex; align-items: center; gap: 4px; cursor: pointer;"><input type="radio" class="radiobox" data-input-id="${currentId}" name="${currentId}ynRadioGroup" value="No"/></label></span>&nbsp;`;
    } else if (
      e === "Dropdown" ||
      e === "singleSelect" ||
      e === "multiSelect"
    ) {
      setDropDownPopup(true);
      setMultiple(e === "multiSelect");
      setOptions([
        { text: "", checked: false },
        { text: "", checked: false },
      ]);
      setDropdownPlaceholder("");
      return;
    } else if (e === "Signature") {
      test = `<img height="24px" width="24px" src="${Signature}" class="signature" data-input-id="${currentId}"></img>`;
    } else if (e === "Linearline") {
      test = `<hr />`;
    }

    if (test) {
      inputboxRef.current += 1;
      insertContent(test);
    }
  };

  const datachips1 = (
    <Menu>
      <Menu.Item
        key="Past Appointment"
        onClick={() => insertContent("{past_appointment}")}
      >
        Past Appointment
      </Menu.Item>
      <Menu.Item
        key="Upcoming Appointment"
        onClick={() => insertContent("{upcoming_appointment}")}
      >
        Upcoming Appointment
      </Menu.Item>
    </Menu>
  );

  const datachips2 = (
    <Menu>
      <Menu.Item
        key="First Name"
        onClick={() => insertContent("{patient_first_name}")}
      >
        First Name
      </Menu.Item>
      <Menu.Item
        key="Last Name"
        onClick={() => insertContent("{patient_last_name}")}
      >
        Last Name
      </Menu.Item>
      <Menu.Item key="Gender" onClick={() => insertContent("{patient_gender}")}>
        Gender
      </Menu.Item>
      <Menu.Item key="DOB" onClick={() => insertContent("{patient_dob}")}>
        DOB
      </Menu.Item>
      <Menu.Item
        key="Address"
        onClick={() => insertContent("{patient_address}")}
      >
        Address
      </Menu.Item>
      <Menu.Item key="Email" onClick={() => insertContent("{patient_email}")}>
        Email
      </Menu.Item>
      <Menu.Item
        key="Phone Number"
        onClick={() => insertContent("{patient_phone_number}")}
      >
        Phone Number
      </Menu.Item>
    </Menu>
  );

  const datachips3 = (
    <Menu>
      <Menu.Item
        key="Provider Name"
        onClick={() => insertContent("{provider_name}")}
      >
        Provider Name
      </Menu.Item>
      <Menu.Item
        key="Provider NPI"
        onClick={() => insertContent("{provider_npi}")}
      >
        Provider NPI
      </Menu.Item>
      <Menu.Item
        key="Address"
        onClick={() => insertContent("{provider_address}")}
      >
        Address
      </Menu.Item>
      <Menu.Item key="Email" onClick={() => insertContent("{provider_email}")}>
        Email
      </Menu.Item>
      <Menu.Item
        key="Phone Number"
        onClick={() => insertContent("{provider_phone_number}")}
      >
        Phone Number
      </Menu.Item>
    </Menu>
  );

  const mainMenu1 = (
    <Menu>
      <Menu.SubMenu
        key="Appointment"
        title={
          <>
            <img src={datachip1} height="14px" width="14px" />
            <span> Appointment</span>
          </>
        }
        popupOffset={[0, 0]}
      >
        {datachips1}
      </Menu.SubMenu>
      <Menu.SubMenu
        key="Patient"
        title={
          <>
            <img src={datachip2} height="14px" width="14px" />
            <span> Patient</span>
          </>
        }
        popupOffset={[0, 0]}
      >
        {datachips2}
      </Menu.SubMenu>
      <Menu.SubMenu
        key="Provider"
        title={
          <>
            <img src={datachip3} height="14px" width="14px" />
            <span> Provider</span>
          </>
        }
        popupOffset={[0, 0]}
      >
        {datachips3}
      </Menu.SubMenu>
    </Menu>
  );

  const mainMenu = (
    <Menu>
      <Menu.Item key="Text Input" onClick={() => setEditorData("TextInput")}>
        <img src={template1} height="14px" width="14px" />
        <span>Text Input</span>
      </Menu.Item>
      <Menu.Item
        key="Short Text Input"
        onClick={() => setEditorData("smTextInput")}
      >
        <img src={template2} height="14px" width="14px" />
        <span>Short Text Input</span>
      </Menu.Item>
      <Menu.Item
        key="Long Text Input"
        onClick={() => setEditorData("sizedTextInput:120px")}
      >
        <img src={template3} height="14px" width="14px" />
        <span>Long Text Input</span>
      </Menu.Item>
      <Menu.Item key="Date picker" onClick={() => setEditorData("DatePicker")}>
        <img src={template4} height="14px" width="14px" />
        <span>Date picker</span>
      </Menu.Item>
      <Menu.Item key="Dropdown" onClick={() => setEditorData("Dropdown")}>
        <img src={template5} height="14px" width="14px" />
        <span>Dropdown</span>
      </Menu.Item>
      <Menu.Item
        key="Single Select"
        onClick={() => setEditorData("singleSelect")}
      >
        <img src={template6} height="14px" width="14px" />
        <span>Single Select</span>
      </Menu.Item>
      <Menu.Item
        key="Multi Select"
        onClick={() => setEditorData("multiSelect")}
      >
        <img src={template7} height="14px" width="14px" />
        <span>Multi Select</span>
      </Menu.Item>
      <Menu.Item key="Yes / No" onClick={() => setEditorData("ynRadioGroup")}>
        <img src={template8} height="14px" width="14px" />
        <span>Yes / No</span>
      </Menu.Item>
      <Menu.Item
        key="Radio button"
        onClick={() => setEditorData("Radio button")}
      >
        <img src={template9} height="14px" width="14px" />
        <span>Radio button</span>
      </Menu.Item>
      <Menu.Item key="Signature" onClick={() => setEditorData("Signature")}>
        <img src={template10} height="14px" width="14px" />
        <span>Signature</span>
      </Menu.Item>
      <Menu.Item key="Linear line" onClick={() => setEditorData("Linearline")}>
        <img src={template11} height="14px" width="14px" />
        <span>Linear line</span>
      </Menu.Item>
    </Menu>
  );

  const macrosMenu = (
    <Menu style={{ maxHeight: "250px", overflowY: "auto" }}>
      {macrosList.length > 0 ? (
        macrosList.map((macro) => (
          <Menu.Item key={macro.id} onClick={() => insertContent(macro.text)}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <text
                x="6"
                y="17"
                fontFamily="system-ui, sans-serif"
                fontSize="14"
                fontWeight="bold"
                fill="currentColor"
              >
                A
              </text>
            </svg>
            <span>{macro.label}</span>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled key="no-macros">
          No macros found
        </Menu.Item>
      )}
    </Menu>
  );

  const handleBlur = (newContent) => {
    const instance = editorRef.current;
    if (instance && instance.editor) {
      syncAttributes(instance.editor);
      const finalHTML = instance.editor.innerHTML;
      setContent(finalHTML);
      setContentToParent(finalHTML);
    } else if (newContent) {
      setContent(newContent);
      setContentToParent(newContent);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      setFromOutside() {
        const instance = editorRef.current;
        if (instance && instance.editor) {
          syncAttributes(instance.editor);
          return instance.editor.innerHTML;
        }
        return content || data;
      },
    }),
    [content, data, syncAttributes],
  );

  // Sync from props only when empty
  useEffect(() => {
      if (
        data &&
        (!content || content === "<p></p>" || content === "<p><br></p>")
      ) {
        setContent(data);
      }
    }, [data, content]);

  useEffect(() => {
    if (ExtraContent !== "") {
      insertContent(ExtraContent);
      clearExtraContent();
    }
  }, [ExtraContent, insertContent, clearExtraContent]);

  // Iframe Event Listeners for constant value synchronization
  useEffect(() => {
    const interval = setInterval(() => {
      const inst = editorRef.current;
      const editorDoc = inst?.editor?.ownerDocument || inst?.ownerDocument;
      if (!inst || !editorDoc) return;

      const handleKeyDown = (e) => {
        if (e.key === "Backspace") {
          const sel = editorDoc.getSelection();
          if (sel && sel.rangeCount > 0) {
            let node = sel.getRangeAt(0).startContainer;
            if (node.nodeType === Node.TEXT_NODE) node = node.parentNode;
            const currentInst = editorRef.current;
            const editorEl = currentInst?.editor;
            while (node && node !== editorEl) {
              if (node.tagName === "SELECT" || node.tagName === "INPUT") {
                e.preventDefault();
                const parent = node.parentNode;
                node.remove();
                if (parent?.tagName === "P" && parent.innerHTML.trim() === "")
                  parent.remove();
                break;
              }
              node = node.parentNode;
            }
          }
        }
        if (e.key === "Tab" || e.key === "Enter") {
          if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
            // Write value to attribute immediately so Jodit serialize sees it
            e.target.setAttribute("value", e.target.value);
            e.stopPropagation();
          }
        }
      };

      const handleInput = (e) => {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
          // Mirror property to attribute immediately so Jodit's serialization sees it
          if (e.target.type === "radio" || e.target.type === "checkbox") {
            if (e.target.checked) e.target.setAttribute("checked", "checked");
            else e.target.removeAttribute("checked");
          } else {
            e.target.setAttribute("value", e.target.value);
          }
          // Exhaustive sync of the whole editor on every interaction
          const currentInst = editorRef.current;
          if (currentInst && currentInst.editor) {
            syncAttributes(currentInst.editor);
          }
        }
      };

      const handleChangeEvent = (e) => {
        const currentInst = editorRef.current;
        if (currentInst && currentInst.editor) {
          syncAttributes(currentInst.editor);
          if (currentInst.synchronize) currentInst.synchronize();
        }
      };

      const handleMouseDown = (e) => {
        if (e.target.tagName === "INPUT" && e.target.type === "radio") {
          e.target.wasChecked = e.target.checked;
        }
      };

      const handleClick = (e) => {
        if (e.target.tagName === "INPUT" && e.target.type === "radio") {
          if (e.target.wasChecked) {
            e.target.checked = false;
            e.target.removeAttribute("checked");
            e.target.dispatchEvent(new Event("change", { bubbles: true }));
            e.target.dispatchEvent(new Event("input", { bubbles: true }));
          } else {
            e.target.setAttribute("checked", "checked");
            if (e.target.name) {
              const group = editorDoc.querySelectorAll(
                `input[type="radio"][name="${e.target.name}"]`
              );
              group.forEach((r) => {
                if (r !== e.target) {
                  r.removeAttribute("checked");
                  r.checked = false;
                }
              });
            }
          }
          const currentInst = editorRef.current;
          if (currentInst && currentInst.editor) {
            syncAttributes(currentInst.editor);
            if (currentInst.synchronize) currentInst.synchronize();
            const finalHTML = currentInst.editor.innerHTML;
            setContent(finalHTML);
            setContentToParent(finalHTML);
          }
        } else if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
          const currentInst = editorRef.current;
          if (currentInst && currentInst.editor) {
            syncAttributes(currentInst.editor);
          }
        }
      };

      editorDoc.addEventListener("keydown", handleKeyDown, true);
      editorDoc.addEventListener("input", handleInput, true);
      editorDoc.addEventListener("change", handleChangeEvent, true);
      editorDoc.addEventListener("mousedown", handleMouseDown, true);
      editorDoc.addEventListener("click", handleClick, true);

      // Clean up loaded HTML attributes immediately on editor mount
      syncAttributes(inst.editor);

      clearInterval(interval);
      return () => {
        editorDoc.removeEventListener("keydown", handleKeyDown, true);
        editorDoc.removeEventListener("input", handleInput, true);
        editorDoc.removeEventListener("change", handleChangeEvent, true);
        editorDoc.removeEventListener("mousedown", handleMouseDown, true);
        editorDoc.removeEventListener("click", handleClick, true);
      };
    }, 200);
    return () => clearInterval(interval);
  }, [syncAttributes]);

  const editorConfig = useMemo(() => {
    const baseButtons = [
      "undo",
      "redo",
      "|",
      "bold",
      "italic",
      "underline",
      "|",
      "ul",
      "ol",
      "|",
      "font",
      "fontsize",
      "|",
      "indent",
      "lineHeight",
      "align",
      "|",
      "table",
    ];

    if (fromTemplate === "Appointment") {
      baseButtons.push("|", "dx", "cpt", "hcpcs");
    }

    return {
      buttons: baseButtons,
      controls: {
        dx: {
          name: "dx",
          icon: false,
          text: "dx",
          // tooltip: "Diagnosis Code",
          exec: () => {
            if (typeof onOpenCodePopupRef.current === "function")
              onOpenCodePopupRef.current("DX");
          },
        },
        cpt: {
          name: "cpt",
          icon: false,
          text: "CPT",
          // tooltip: "CPT Code",
          exec: () => {
            if (typeof onOpenCodePopupRef.current === "function")
              onOpenCodePopupRef.current("CPT");
          },
        },
        hcpcs: {
          name: "hcpcs",
          icon: false,
          text: "HCPCS",
          // tooltip: "HCPCS Code",
          exec: () => {
            if (typeof onOpenCodePopupRef.current === "function")
              onOpenCodePopupRef.current("HCPCS");
          },
        },
      },
      toolbarAdaptive: false,
      toolbarSticky: true,
      askBeforePasteHTML: false,
      height: 500,
      width: "100%",
      readonly: false,
      showStatusbar: false,
      statusbar: false,
      placeholder: "",
      showPlaceholder: false,
      allowResizeY: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      cleanHTML: false,
      beautify: false,
      allowAttributes: {
        "*": ["*"], // Allow everything to prevent Jodit from stripping our hard-won attributes
      },
    };
  }, [fromTemplate]);

  return (
    <>
      {Mode === "Editor" ? (
        <div className="jodit_buttons">
          <div
            className={
              fromWhere === "Appointment"
                ? "for_jodit_inputs"
                : fromWhere === "Notes"
                  ? "for_jodit_inputs_notes"
                  : fromWhere === "Dashboard"
                    ? "for_jodit_inputs_dashboard"
                    : "for_jodit_inputs_left"
            }
          >
            <Dropdown
              overlay={mainMenu}
              trigger={["hover"]}
              placement="bottomLeft"
            >
              <Button>
                <img
                  src={template1}
                  height="14px"
                  width="14px"
                  style={{ marginRight: "6px", verticalAlign: "middle" }}
                  alt=""
                />
                Input Fields <DownOutlined />
              </Button>
            </Dropdown>
            <Dropdown
              overlay={mainMenu1}
              trigger={["hover"]}
              placement="bottomLeft"
            >
              <Button>
                <img
                  src={datachip1}
                  height="14px"
                  width="14px"
                  style={{ marginRight: "6px", verticalAlign: "middle" }}
                  alt=""
                />
                Data chips <DownOutlined />
              </Button>
            </Dropdown>
            <Popup
              trigger={
                <div style={{ display: 'inline-block' }}>
                  <Dropdown
                    overlay={macrosMenu}
                    trigger={["hover"]}
                    placement="bottomLeft"
                  >
                    <Button>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      >
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <text
                          x="6"
                          y="17"
                          fontFamily="system-ui, sans-serif"
                          fontSize="14"
                          fontWeight="bold"
                          fill="currentColor"
                        >
                          A
                        </text>
                      </svg>
                      Macros <DownOutlined />
                    </Button>
                  </Dropdown>
                </div>
              }
              open={step === "29.6" || step === "29.8" || step === "29.10"}
              position="right center"
              className="no-sui-arrow"
              style={{ zIndex: 10000, width: "300px", maxWidth: "none" }}
              offset={[60, 10]} // Adjust the [x, y] offset here to hit the sweet spot!
              popperModifiers={[{ name: 'flip', enabled: false }, { name: 'preventOverflow', enabled: true }]}
              on={[]}
              content={
                step === "29.6" ? (
                  <GetStartedPopup
                    title="Macro Button Usage"
                    description='Click on the "Macro" button to list the added macro button and select them to be add in the templates.'
                    currentStep={6}
                    totalSteps={10}
                    arrowPosition="left-top"
                    onNext={() => {
                      history.replace({
                        pathname: "/settings/templates",
                        search: "?step=29.7",
                      });
                    }}
                    onBack={() => {
                      history.replace({
                        pathname: "/settings/templates",
                        search: "?step=29.5",
                      });
                    }}
                    onClose={() => {
                      history.replace({
                        pathname: location.pathname,
                        search: "",
                      });
                    }}
                    closeOnOutsideClick={true}
                    showBackdrop={false}
                    topClose={true}
                    width="300px"
                  />
                ) : step === "29.8" ? (
                  <GetStartedPopup
                    title="Macro Button Usage"
                    bullets={[
                      "Click on the \"Macro\" button to list the added macro button and select them to be add in the clinical notes."
                    ]}
                    currentStep={8}
                    totalSteps={10}
                    arrowPosition="left-top"
                    onNext={() => {
                      history.replace({
                        pathname: `/patient/patientdashboard/1`,
                        search: "?step=29.9",
                        state: { isMockTour: true }
                      });
                    }}
                    onBack={() => {
                      history.replace({
                        pathname: location.pathname,
                        search: "?step=29.7",
                      });
                    }}
                    onClose={() => {
                      history.replace({
                        pathname: location.pathname,
                        search: "",
                      });
                    }}
                    closeOnOutsideClick={true}
                    showBackdrop={false}
                    topClose={true}
                  />
                ) : step === "29.10" ? (
                  <GetStartedPopup
                    title="Macro Button Usage"
                    bullets={[
                      "Click on the \"Macro\" button to list the added macro button and select them to be add in the forms."
                    ]}
                    currentStep={10}
                    totalSteps={10}
                    arrowPosition="left-top"
                    onGotIt={async () => {
                      try {
                        const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
                        await axiosInstance.post(
                          `/vozo/account-setup/complete-step?patient_id=${userID}&step_id=29`
                        );
                      } catch (error) {
                        console.error("Failed to mark step as complete", error);
                      }
                      history.push({
                        pathname: `/settings/accountsetup`,
                        state: { getstartedopen: false },
                      });
                    }}
                    onBack={() => {
                      history.replace({
                        pathname: location.pathname,
                        search: "?step=29.9",
                      });
                    }}
                    onClose={() => {
                      history.replace({
                        pathname: location.pathname,
                        search: "",
                      });
                    }}
                    closeOnOutsideClick={true}
                    showBackdrop={false}
                    topClose={true}
                  />
                ) : <></>
              }
            />
          </div>
          <JoditEditor
            ref={editorRef}
            value={content}
            config={editorConfig}
            tabIndex={1}
            onBlur={handleBlur}
            onChange={handleBlur}
          />
        </div>
      ) : (
        <Div padding="20px 20px 20px 30px"></Div>
      )}

      {/* Premium Dropdown Modal UI */}
      <Modal
        className="ed-opt-modal-root forSelect_dropdown_notes"
        centered
        show={DropDownPopup}
        onHide={() => setDropDownPopup(false)}
        style={{ zIndex: 5000 }}
      >
        <Modal.Body className="ed-opt-modal-body" style={{ padding: 0 }}>
          <div className="ed-opt-modal-wrap">
            <div className="ed-opt-header">
              <span className="ed-opt-title">Add your Options</span>
              <button
                className="ed-opt-close-btn"
                onClick={() => setDropDownPopup(false)}
              >
                &times;
              </button>
            </div>

            <div className="ed-opt-placeholder-row">
              <input
                type="text"
                className="ed-opt-placeholder-input"
                placeholder="Enter placeholder"
                value={dropdownPlaceholder}
                
                onChange={(e) => setDropdownPlaceholder(e.target.value)}
              />
            </div>

            <div className="ed-opt-box">
              <div className="ed-opt-list">
                {options.map((option, index) => (
                  <div key={index} className="ed-opt-row">
                    <span
                      className="ed-opt-checkbox-icon"
                      onClick={() => toggleOption(index)}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="15"
                          height="15"
                          rx="1"
                          stroke="#A0AEC0"
                          strokeWidth="1.2"
                          fill="#fff"
                        />
                        {option.checked && (
                          <path
                            d="M4 8l3 3 5-5"
                            stroke="#3182ce"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        )}
                      </svg>
                    </span>
                    <input
                      className="ed-opt-input"
                      type="text"
                      value={option.text}
                         disabled={option.text?.toLowerCase().includes("other")
                      }
                      onChange={(e) => updateOption(index, e.target.value)}
                      placeholder={`Option ${index + 1}`}
                      autoFocus={index === options.length - 1}
                    />
                    <button
                      className="ed-opt-delete-btn"
                      onClick={() => deleteOption(index)}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                ))}
              </div>

              <div className="ed-opt-add-row">
                <button className="ed-opt-add-btn" onClick={addBlankOption}>
                  + Add Option
                </button>
                <span className="ed-opt-or">or</span>
                <button
                  className="ed-opt-add-other-btn"
                  onClick={addOtherOption}
                  disabled={options.some(
                      (option) => option.text?.trim().toLowerCase() === "other"
                    )}                >
                  Add Other
                </button>
              </div>

              {errorMessage && (
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                    padding: "0 16px 8px",
                    marginTop: "-8px",
                  }}
                >
                  {errorMessage}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="for_select_footer_notes">
          <Button
            className="close_active"
            variant="light"
            onClick={() => setDropDownPopup(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOkDropdown}
            className="save_active fortextColor"
            variant="primary"
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default memo(forwardRef(EditDocument));
